// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   Prompt 영역 — 알아보기/생성/목록/Few-shot 공유 (Figma 70:5021 외)
   헤더는 components/AppHeader (별도 CSS)
   ======================================================================== */

.prompt {
  min-height: 100vh;
  background: var(--fg-bg-dark);
  font-family: var(--font-sans);
  color: var(--fg-text-basic);
}

.prompt__layout {
  display: flex;
  background: var(--fg-bg-content);
  margin: 0 16px;
  border-radius: 16px 16px 0 0;
  min-height: calc(100vh - 52px);
  box-shadow: 0 0 6.3px 1px rgba(0, 0, 0, 0.26);
  overflow: hidden;
}

/* ───────── 사이드바 ───────── */
.prompt__sidebar {
  width: 272px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: var(--fg-bg-content);
  overflow: hidden;
  transition:
    width 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    padding 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    gap 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 접힘 상태 — Figma sidebar-closed (2030:14844) */
.prompt__sidebar--collapsed {
  width: 64px;
  align-items: center;
  gap: 24px;
  padding: 30px 16px;
}

.prompt__sidebar--collapsed>* {
  animation: promptSidebarFadeIn 0.24s ease both;
}

@keyframes promptSidebarFadeIn {
  from {
    opacity: 0;
    transform: translateY(2px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.prompt__sidebar-collapsed-nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.prompt__sidebar-mini-btn {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.prompt__sidebar-mini-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}

.prompt__sidebar-mini-btn:focus-visible {
  outline: none;
  background: rgba(0, 0, 0, 0.08);
}

.prompt__sidebar-mini-btn--active {
  background: #fff;
}

.prompt__sidebar-toggle {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.prompt__sidebar-toggle:hover {
  background: rgba(0, 0, 0, 0.04);
}

.prompt__sidebar-title {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.prompt__sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.prompt__sidebar-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px;
  background: transparent;
  border: 0;
  border-radius: 12px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic);
  cursor: pointer;
  text-align: left;
  transition: var(--transition-fast);
}

.prompt__sidebar-item:hover {
  background: rgba(0, 0, 0, 0.03);
}

.prompt__sidebar-item--active {
  background: #fff;
}

.prompt__sidebar-count {
  margin-left: auto;
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray);
}

/* AI 프롬프트 생성 (확장형) */
.prompt__sidebar-vertical {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 10px;
  border-radius: 12px;
  transition: var(--transition-fast);
}

.prompt__sidebar-vertical:hover {
  background: rgba(0, 0, 0, 0.03);
}

.prompt__sidebar-vertical--active {
  background: #fff;
}

.prompt__sidebar-vertical-head {
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 0;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic);
  cursor: pointer;
  padding: 0;
  text-align: left;
}

.prompt__sidebar-vertical-head>span:nth-of-type(1) {
  flex: 1 1;
}

.prompt__sidebar-arrow {
  display: inline-grid;
  place-items: center;
  transition: transform 0.2s ease;
  color: var(--fg-text-basic);
}

.prompt__sidebar-arrow--open {
  transform: rotate(180deg);
}

.prompt__sidebar-sub {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 20px;
  margin-left: 14px;
  border-left: 1px solid var(--fg-text-basic);
}

.prompt__sidebar-sub-item {
  background: transparent;
  border: 0;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic);
  cursor: pointer;
  text-align: left;
  padding: 0;
  line-height: 1;
  height: 17px;
  display: flex;
  align-items: center;
  transition: var(--transition-fast);
}

.prompt__sidebar-sub-item:hover {
  color: var(--fg-side-hover);
}

.prompt__sidebar-sub-item--active {
  color: var(--fg-side-hover);
  font-weight: 600;
}

/* ───────── 메인 영역 ───────── */
.prompt__main {
  flex: 1 1;
  min-width: 0;
  background: #fff;
  border-radius: 16px 16px 0 0;
  overflow-y: auto;
}

.prompt__content {
  max-width: 1616px;
  padding: 30px 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

/* ========================================================================
   PromptIntro — 알아보기 페이지
   ======================================================================== */

.prompt-intro__section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.prompt-intro__heading {
  display: flex;
  align-items: center;
  gap: 4px;
}

.prompt-intro__h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  line-height: 40px;
  color: var(--fg-text-basic);
}

.prompt-intro__heading-help {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  color: var(--fg-text-gray);
  cursor: pointer;
}

.prompt-intro__h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.prompt-intro__sub {
  margin: 0;
  font-size: 14px;
  color: var(--fg-text-gray);
}

.prompt-intro__lead {
  margin: 0;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
}

/* Flow Steps */
.prompt-intro__flow {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.prompt-intro__flow-row {
  display: contents;
}

.prompt-intro__step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 127px;
  padding: 16px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-text-gray);
  border-radius: 12px;
  color: var(--fg-text-basic);
}

.prompt-intro__step svg {
  color: var(--fg-side-hover);
}

.prompt-intro__step--active {
  background: var(--fg-bg-step-active);
  border-color: var(--fg-side-hover);
}

.prompt-intro__step--active svg {
  color: var(--fg-side-hover);
}

.prompt-intro__step-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
  text-align: center;
  white-space: nowrap;
}

.prompt-intro__step-desc {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--fg-text-gray);
  text-align: center;
}

.prompt-intro__flow-arrow {
  display: inline-grid;
  place-items: center;
  color: var(--fg-text-basic);
}

/* Grid layouts */
.prompt-intro__grid {
  display: grid;
  gap: 20px;
}

.prompt-intro__grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.prompt-intro__grid--4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.prompt-intro__grid--5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

/* Technique 카드 */
.prompt-intro__technique {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 208px;
  padding: 12px 20px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.prompt-intro__technique-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.prompt-intro__technique-sub {
  margin: 0;
  font-size: 13px;
  line-height: 1;
  color: var(--fg-text-gray);
}

.prompt-intro__technique-summary {
  margin: 0;
  font-size: 15px;
  line-height: 24px;
  color: var(--fg-text-basic);
}

.prompt-intro__technique-example {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 4px;
}

.prompt-intro__technique-tag {
  flex-shrink: 0;
  padding: 4px 6px;
  background: var(--fg-bg-tag-lime);
  border-radius: 4px;
  font-size: 13px;
  color: var(--fg-text-basic);
}

.prompt-intro__technique-quote {
  margin: 0;
  padding-top: 2px;
  font-size: 14px;
  line-height: 20px;
  color: var(--fg-class-green);
}

/* Comparison 카드 */
.prompt-intro__compare {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 20px 24px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.prompt-intro__compare--fewshot {
  background: var(--fg-bg-fewshot);
}

.prompt-intro__compare-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.prompt-intro__compare-sub {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.prompt-intro__compare-desc {
  margin: 0;
  font-size: 15px;
  line-height: 24px;
  color: var(--fg-text-basic);
}

.prompt-intro__compare-list {
  list-style: none;
  margin: 0;
  padding: 0 0 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.prompt-intro__compare-list li {
  position: relative;
  padding-left: 12px;
  font-size: 15px;
  line-height: 24px;
  color: var(--fg-text-basic);
}

.prompt-intro__compare-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  width: 4px;
  height: 4px;
  background: var(--fg-text-basic);
  border-radius: 9999px;
}

.prompt-intro__compare-tag {
  align-self: flex-start;
  padding: 4px 6px;
  background: var(--fg-bg-content);
  border-radius: 4px;
  font-size: 13px;
  color: var(--fg-text-basic);
}

/* Tip 카드 */
.prompt-intro__tip {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 20px 24px;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.prompt-intro__tip-number {
  display: inline-grid;
  place-items: center;
  width: 46px;
  height: 46px;
  background: var(--fg-numbering-bg);
  border-radius: 23px;
  color: #fff;
  font-size: 20px;
  font-weight: 900;
  line-height: 26px;
}

.prompt-intro__tip-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.prompt-intro__tip-desc {
  margin: 0;
  font-size: 15px;
  line-height: 24px;
  color: var(--fg-text-gray);
}

/* ───────── 반응형 ───────── */
@media (max-width: 1280px) {
  .prompt-intro__grid--5 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .prompt-intro__grid--4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}


/* ========================================================================
   PromptGenerator — AI 프롬프트/Few-shot 생성 (Figma 71:2414, 71:2767)
   ======================================================================== */

.prompt-gen__section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 탭 */
.prompt-gen__tabs {
  display: flex;
  border-bottom: 1px solid var(--fg-line);
}

.prompt-gen__tab {
  flex: 1 1;
  padding: 10px;
  background: transparent;
  border: 0;
  border-bottom: 3px solid transparent;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
  margin-bottom: -1px;
}

.prompt-gen__tab:hover {
  color: var(--fg-side-hover);
}

.prompt-gen__tab--active {
  border-bottom-color: var(--fg-text-basic);
  font-weight: 600;
}

/* 입력 폼 */
.prompt-gen__form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.prompt-gen__label {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.prompt-gen__textarea {
  width: 100%;
  min-height: 162px;
  padding: 20px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  resize: vertical;
  outline: none;
  transition: var(--transition-fast);
}

.prompt-gen__textarea:focus {
  border-color: var(--fg-button);
}

.prompt-gen__textarea::placeholder {
  color: var(--fg-text-gray);
}

.prompt-gen__form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.prompt-gen__count {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--fg-text-basic);
}

.prompt-gen__count-select {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.prompt-gen__count-select select {
  appearance: none;
  -webkit-appearance: none;
  padding: 6px 28px 6px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 6px;
  font-family: inherit;
  font-size: 14px;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.prompt-gen__count-select>svg {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--fg-text-gray);
}

.prompt-gen__btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 10px 12px;
  background: var(--fg-button);
  border: 0;
  border-radius: 12px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: var(--transition-fast);
  height: 42px;
  padding: 6px 12px;
}

.prompt-gen__btn-primary:hover {
  background: var(--fg-button-hover);
}

.prompt-gen__btn-primary--ghost {
  background: var(--fg-bg-litepp);
  color: var(--fg-button-hover);
}

.prompt-gen__btn-primary--ghost:hover {
  background: #d8dbed;
}

.prompt-gen__btn-primary:disabled,
.prompt-gen__btn-primary--ghost:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 추천 카드 */
.prompt-gen__suggestions {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.prompt-gen__suggestion {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding: 12px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: var(--transition-fast);
}

.prompt-gen__suggestion:hover {
  border-color: var(--fg-button);
}

.prompt-gen__suggestion-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.prompt-gen__suggestion-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
}

.prompt-gen__suggestion-summary {
  margin: 0;
  font-size: 14px;
  color: var(--fg-text-gray);
  line-height: 1.4;
}

.prompt-gen__suggestion-tag {
  flex-shrink: 0;
  padding: 4px;
  background: var(--fg-bg-warning);
  border-radius: 4px;
  font-size: 12px;
  color: var(--fg-anti-red);
}

/* 결과 박스 */
.prompt-gen__result {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background: #f8f8f8;
  border-radius: 12px;
}

.prompt-gen__result-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.prompt-gen__result-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.prompt-gen__result-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.prompt-gen__btn-toolbar {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 5px 7px 7px;
  border: 0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-fast);
}

.prompt-gen__btn-toolbar--ghost {
  background: var(--fg-bg-litepp);
  color: var(--fg-button-hover);
}

.prompt-gen__btn-toolbar--ghost:hover {
  background: #d8dbed;
}

.prompt-gen__btn-toolbar--primary {
  background: var(--fg-button);
  color: #fff;
}

.prompt-gen__btn-toolbar--primary:hover {
  background: var(--fg-button-hover);
}

.prompt-gen__refresh-icon {
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
}

.prompt-gen__result-textarea {
  width: 100%;
  min-height: 162px;
  padding: 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  resize: vertical;
  outline: none;
}

.prompt-gen__result-textarea:focus {
  border-color: var(--fg-button);
}

/* Few-shot 결과 항목 */
.prompt-gen__fewshot-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.prompt-gen__fewshot-item {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.prompt-gen__fewshot-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.prompt-gen__fewshot-row p {
  margin: 0;
  flex: 1 1;
  font-size: 15px;
  line-height: 24px;
  color: var(--fg-text-basic);
  white-space: pre-wrap;
}

.prompt-gen__fewshot-label {
  flex-shrink: 0;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.prompt-gen__fewshot-label--user {
  background: var(--fg-bg-mychat);
  color: var(--fg-button-hover);
}

.prompt-gen__fewshot-label--assistant {
  background: var(--fg-bg-tag-lime);
  color: var(--fg-class-green);
}

.prompt-gen__fewshot-remove {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-gray);
  cursor: pointer;
}

.prompt-gen__fewshot-remove:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-anti-red);
}

@media (max-width: 1280px) {
  .prompt-gen__suggestions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}


/* ========================================================================
   PromptList — 프롬프트 목록 (Figma 71:3011)
   ======================================================================== */

/* 카운터 행 */
.prompt-list__stats-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.prompt-list__stats {
  display: flex;
  align-items: center;
  gap: 8px;
}

.prompt-list__stat {
  display: inline-flex;
  align-items: end;
  gap: 4px;
  font-size: 15px;
  line-height: 24px;
  color: var(--fg-text-basic);
  white-space: nowrap;
}

.prompt-list__stat b {
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
}

.prompt-list__stat-divider {
  width: 1px;
  height: 22px;
  background: var(--fg-line);
}

/* 필터 행 */
.prompt-list__filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.prompt-list__filter-left,
.prompt-list__filter-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.prompt-list__bulk-toggle {
  width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  background: #c2c2c2;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  padding: 0;
  transition: var(--transition-fast);
}

.prompt-list__bulk-toggle--active,
.prompt-list__bulk-toggle--partial {
  background: var(--fg-side-hover);
}

.prompt-list__bulk-toggle:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.prompt-list__select-action-wrap {
  position: relative;
  display: inline-flex;
}

.prompt-list__select-action {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 8px 8px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.prompt-list__select-action:hover {
  border-color: var(--fg-button);
}

.prompt-list__select-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 30;
  min-width: 180px;
  padding: 6px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 2px;
  animation: prompt-list-menu-fade 120ms ease-out;
}

@keyframes prompt-list-menu-fade {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.prompt-list__select-menu-item {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  color: var(--fg-text-basic);
  text-align: left;
  cursor: pointer;
  transition: var(--transition-fast);
}

.prompt-list__select-menu-item>svg {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.prompt-list__select-menu-item:hover:not(:disabled) {
  background: var(--fg-bg-content);
}

.prompt-list__select-menu-item:disabled {
  color: var(--fg-text-gray);
  cursor: not-allowed;
}

.prompt-list__select-menu-item--danger {
  color: var(--fg-anti-red);
}

.prompt-list__select-menu-item--danger:hover:not(:disabled) {
  background: rgba(239, 68, 68, 0.08);
}

.prompt-list__select-count {
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
}

/* 검색 */
.prompt-list__search {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px 7px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 30px;
  width: 240px;
  height: 42px;
}

.prompt-list__search-input {
  flex: 1 1;
  min-width: 0;
  border: 0;
  outline: none;
  font-family: inherit;
  font-size: 16px;
  background: transparent;
  color: var(--fg-text-basic);
}

.prompt-list__search-input::placeholder {
  color: var(--fg-text-gray);
}

.prompt-list__search>svg {
  flex-shrink: 0;
  color: var(--fg-text-gray);
}

/* 정렬 */
.prompt-list__sort-wrap {
  position: relative;
  display: inline-flex;
}

.prompt-list__sort {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 8px 8px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.prompt-list__sort:hover {
  border-color: var(--fg-button);
}

.prompt-list__sort-menu {
  right: 0;
  left: auto;
  min-width: 160px;
}

.prompt-list__select-menu-item--active {
  background: var(--fg-bg-content);
  color: var(--fg-text-purple);
}

/* 뷰 토글 */
.prompt-list__view-toggle {
  display: inline-flex;
}

.prompt-list__view-btn {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.prompt-list__view-btn:first-child {
  border-radius: 8px 0 0 8px;
  border-right: 0;
}

.prompt-list__view-btn:last-child {
  border-radius: 0 8px 8px 0;
}

.prompt-list__view-btn--active {
  background: #dfdced;
  color: var(--fg-button-hover);
}

/* 카드 그리드 */
.prompt-list__cards {
  display: grid;
  gap: 20px;
}

.prompt-list__cards--grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.prompt-list__cards--list {
  grid-template-columns: 1fr;
}

@media (max-width: 1440px) {
  .prompt-list__cards--grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.prompt-list__empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 60px 20px;
  color: var(--fg-text-gray);
}

/* 카드 */
.prompt-list__card {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  transition: var(--transition-fast);
}

.prompt-list__card:hover {
  border-color: var(--fg-button);
}

.prompt-list__card--selected {
  border-color: var(--fg-side-hover);
  box-shadow: 0 0 0 1px var(--fg-side-hover);
}

.prompt-list__card-check {
  flex-shrink: 0;
  padding-top: 6px;
}

.prompt-list__checkbox {
  width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  background: #c2c2c2;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  padding: 0;
  transition: var(--transition-fast);
}

.prompt-list__checkbox--checked {
  background: var(--fg-side-hover);
}

.prompt-list__card-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.prompt-list__card-head {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.prompt-list__card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.prompt-list__card-date {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.prompt-list__card-summary {
  margin: 0;
  font-size: 15px;
  line-height: 24px;
  color: var(--fg-text-basic);
}

.prompt-list__card-quote {
  padding: 8px;
  height: 68px;
  background: #f8f8f8;
  border-radius: 8px;
  overflow: hidden;
}

.prompt-list__card-quote p {
  margin: 0;
  font-size: 15px;
  line-height: 24px;
  color: var(--fg-text-gray);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.prompt-list__card-actions {
  display: flex;
  justify-content: flex-end;
}

.prompt-list__icon-btn {
  position: relative;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.prompt-list__icon-btn:hover {
  background: rgba(0, 0, 0, 0.04);
}

.prompt-list__icon-btn--danger {
  color: var(--fg-anti-red);
}

.prompt-list__icon-btn--active {
  color: var(--fg-button);
}

.prompt-list__icon-btn-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  display: grid;
  place-items: center;
  background: var(--fg-button);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 999px;
  border: 2px solid #fff;
  line-height: 1;
}

.prompt-list__icon-dot {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 5px;
  height: 5px;
  background: var(--fg-anti-red);
  border-radius: 9999px;
}

/* Few-shot 카드 (입력/출력 블록) */
.prompt-list__card-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.prompt-list__card-block-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--fg-text-basic);
}

/* 리스트 뷰: 가로형 카드 */
.prompt-list__cards--list .prompt-list__card-body {
  flex-direction: row;
  gap: 24px;
  align-items: flex-start;
}

.prompt-list__cards--list .prompt-list__card-head {
  flex: 0 0 200px;
}

.prompt-list__cards--list .prompt-list__card-summary {
  flex: 0 0 240px;
}

.prompt-list__cards--list .prompt-list__card-quote {
  flex: 1 1;
  min-width: 0;
  height: auto;
  max-height: 68px;
}

.prompt-list__cards--list .prompt-list__card-actions {
  flex-shrink: 0;
}

/* 모바일 전용 가로 서브내비 — 기본(데스크톱)은 숨김, ≤720px 에서만 노출 */
.prompt__subnav-mobile {
  display: none;
}

/* ========================================================================
   모바일 (≤720px) — 프롬프트 화면 (Intro / Generator / List / Edit).
   공유 셸(.prompt__*, .prompt-list__*)을 agent/mcp/edu/project 등과 함께 쓰므로
   .prompt-page 마커로 스코프해 다른 기능 화면 영향 차단.
   그리드는 minmax(0,1fr) 필수 — 1fr=minmax(auto,1fr) 이라 긴 콘텐츠가 트랙을
   밀어 오버플로/잘림이 생긴다(지식베이스 파일명 잘림과 동일 원인).
   ======================================================================== */
@media (max-width: 720px) {
  /* 레이아웃 — 섹션 내비는 글로벌 햄버거 드로어로 이동, 본문만 풀폭 */
  .prompt-page .prompt__layout {
    margin: 0 8px;
    flex-direction: column;
  }
  /* 데스크톱 세로 사이드바 + 모바일 상단 탭 스트립 모두 숨김
     (프롬프트 섹션 내비는 글로벌 드로어의 '프롬프트' 펼침 항목에서 처리) */
  .prompt-page .prompt__sidebar { display: none; }
  .prompt-page .prompt__subnav-mobile { display: none; }

  .prompt-page .prompt__content {
    padding: 20px 16px;
    gap: 28px;
  }

  .prompt-page .prompt-intro__h1 {
    font-size: 22px;
    line-height: 32px;
  }

  /* PromptIntro — 카드 그리드 1열 */
  .prompt-page .prompt-intro__grid--2,
  .prompt-page .prompt-intro__grid--4,
  .prompt-page .prompt-intro__grid--5 {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  /* PromptGenerator — 추천 카드 1열, 액션 행 줄바꿈 */
  .prompt-page .prompt-gen__suggestions {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  .prompt-page .prompt-gen__form-actions,
  .prompt-page .prompt-gen__result-actions {
    flex-wrap: wrap;
  }

  /* PromptList — 카드 1열(그리드/리스트 공통) + 툴바 정리 */
  .prompt-page .prompt-list__cards--grid,
  .prompt-page .prompt-list__cards--list {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  .prompt-page .prompt-list__stats-row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .prompt-page .prompt-list__stats {
    flex-wrap: wrap;
    gap: 6px 8px;
  }

  .prompt-page .prompt-list__filter-right {
    width: 100%;
    flex-wrap: wrap;
  }

  .prompt-page .prompt-list__search {
    flex: 1 1;
    width: auto;
    min-width: 0;
  }

  /* 그리드/리스트 토글은 모바일에서 1열 고정이라 무의미 → 숨김 */
  .prompt-page .prompt-list__view-toggle {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/Prompt.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,4BAA4B;EAC5B,8BAA8B;EAC9B,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB;;;0CAGwC;AAC1C;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;6EAE6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;;AAGA;;6EAE6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,MAAM;AACN;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;;AAGA;;6EAE6E;;AAE7E,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,yEAAyE;EACzE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,OAAO;AACP;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,OAAO;AACP;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA,SAAS;AACT;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,OAAO;AACP;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;;AAEA;;;;;;6EAM6E;AAC7E;EACE,0CAA0C;EAC1C;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;+CAC6C;EAC7C,gCAAgC,aAAa,EAAE;EAC/C,sCAAsC,aAAa,EAAE;;EAErD;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,4BAA4B;EAC5B;;;IAGE,qCAAqC;IACrC,SAAS;EACX;;EAEA,yCAAyC;EACzC;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;;IAEE,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;;IAEE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA,uCAAuC;EACvC;IACE,aAAa;EACf;AACF","sourcesContent":["/* ========================================================================\n   Prompt 영역 — 알아보기/생성/목록/Few-shot 공유 (Figma 70:5021 외)\n   헤더는 components/AppHeader (별도 CSS)\n   ======================================================================== */\n\n.prompt {\n  min-height: 100vh;\n  background: var(--fg-bg-dark);\n  font-family: var(--font-sans);\n  color: var(--fg-text-basic);\n}\n\n.prompt__layout {\n  display: flex;\n  background: var(--fg-bg-content);\n  margin: 0 16px;\n  border-radius: 16px 16px 0 0;\n  min-height: calc(100vh - 52px);\n  box-shadow: 0 0 6.3px 1px rgba(0, 0, 0, 0.26);\n  overflow: hidden;\n}\n\n/* ───────── 사이드바 ───────── */\n.prompt__sidebar {\n  width: 272px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  background: var(--fg-bg-content);\n  overflow: hidden;\n  transition:\n    width 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    padding 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    gap 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 접힘 상태 — Figma sidebar-closed (2030:14844) */\n.prompt__sidebar--collapsed {\n  width: 64px;\n  align-items: center;\n  gap: 24px;\n  padding: 30px 16px;\n}\n\n.prompt__sidebar--collapsed>* {\n  animation: promptSidebarFadeIn 0.24s ease both;\n}\n\n@keyframes promptSidebarFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(2px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.prompt__sidebar-collapsed-nav {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.prompt__sidebar-mini-btn {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.prompt__sidebar-mini-btn:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.prompt__sidebar-mini-btn:focus-visible {\n  outline: none;\n  background: rgba(0, 0, 0, 0.08);\n}\n\n.prompt__sidebar-mini-btn--active {\n  background: #fff;\n}\n\n.prompt__sidebar-toggle {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.prompt__sidebar-toggle:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.prompt__sidebar-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.prompt__sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.prompt__sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 10px;\n  background: transparent;\n  border: 0;\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  text-align: left;\n  transition: var(--transition-fast);\n}\n\n.prompt__sidebar-item:hover {\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.prompt__sidebar-item--active {\n  background: #fff;\n}\n\n.prompt__sidebar-count {\n  margin-left: auto;\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n}\n\n/* AI 프롬프트 생성 (확장형) */\n.prompt__sidebar-vertical {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 10px;\n  border-radius: 12px;\n  transition: var(--transition-fast);\n}\n\n.prompt__sidebar-vertical:hover {\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.prompt__sidebar-vertical--active {\n  background: #fff;\n}\n\n.prompt__sidebar-vertical-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: transparent;\n  border: 0;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  padding: 0;\n  text-align: left;\n}\n\n.prompt__sidebar-vertical-head>span:nth-of-type(1) {\n  flex: 1;\n}\n\n.prompt__sidebar-arrow {\n  display: inline-grid;\n  place-items: center;\n  transition: transform 0.2s ease;\n  color: var(--fg-text-basic);\n}\n\n.prompt__sidebar-arrow--open {\n  transform: rotate(180deg);\n}\n\n.prompt__sidebar-sub {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-left: 20px;\n  margin-left: 14px;\n  border-left: 1px solid var(--fg-text-basic);\n}\n\n.prompt__sidebar-sub-item {\n  background: transparent;\n  border: 0;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  text-align: left;\n  padding: 0;\n  line-height: 1;\n  height: 17px;\n  display: flex;\n  align-items: center;\n  transition: var(--transition-fast);\n}\n\n.prompt__sidebar-sub-item:hover {\n  color: var(--fg-side-hover);\n}\n\n.prompt__sidebar-sub-item--active {\n  color: var(--fg-side-hover);\n  font-weight: 600;\n}\n\n/* ───────── 메인 영역 ───────── */\n.prompt__main {\n  flex: 1;\n  min-width: 0;\n  background: #fff;\n  border-radius: 16px 16px 0 0;\n  overflow-y: auto;\n}\n\n.prompt__content {\n  max-width: 1616px;\n  padding: 30px 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n/* ========================================================================\n   PromptIntro — 알아보기 페이지\n   ======================================================================== */\n\n.prompt-intro__section {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.prompt-intro__heading {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.prompt-intro__h1 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 40px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-intro__heading-help {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n}\n\n.prompt-intro__h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-intro__sub {\n  margin: 0;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n}\n\n.prompt-intro__lead {\n  margin: 0;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n/* Flow Steps */\n.prompt-intro__flow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.prompt-intro__flow-row {\n  display: contents;\n}\n\n.prompt-intro__step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  min-width: 127px;\n  padding: 16px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-text-gray);\n  border-radius: 12px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-intro__step svg {\n  color: var(--fg-side-hover);\n}\n\n.prompt-intro__step--active {\n  background: var(--fg-bg-step-active);\n  border-color: var(--fg-side-hover);\n}\n\n.prompt-intro__step--active svg {\n  color: var(--fg-side-hover);\n}\n\n.prompt-intro__step-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n  text-align: center;\n  white-space: nowrap;\n}\n\n.prompt-intro__step-desc {\n  margin: 0;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n  text-align: center;\n}\n\n.prompt-intro__flow-arrow {\n  display: inline-grid;\n  place-items: center;\n  color: var(--fg-text-basic);\n}\n\n/* Grid layouts */\n.prompt-intro__grid {\n  display: grid;\n  gap: 20px;\n}\n\n.prompt-intro__grid--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.prompt-intro__grid--4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.prompt-intro__grid--5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n/* Technique 카드 */\n.prompt-intro__technique {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-height: 208px;\n  padding: 12px 20px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.prompt-intro__technique-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-intro__technique-sub {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1;\n  color: var(--fg-text-gray);\n}\n\n.prompt-intro__technique-summary {\n  margin: 0;\n  font-size: 15px;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-intro__technique-example {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.prompt-intro__technique-tag {\n  flex-shrink: 0;\n  padding: 4px 6px;\n  background: var(--fg-bg-tag-lime);\n  border-radius: 4px;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-intro__technique-quote {\n  margin: 0;\n  padding-top: 2px;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--fg-class-green);\n}\n\n/* Comparison 카드 */\n.prompt-intro__compare {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 20px 20px 24px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.prompt-intro__compare--fewshot {\n  background: var(--fg-bg-fewshot);\n}\n\n.prompt-intro__compare-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-intro__compare-sub {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.prompt-intro__compare-desc {\n  margin: 0;\n  font-size: 15px;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-intro__compare-list {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 12px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.prompt-intro__compare-list li {\n  position: relative;\n  padding-left: 12px;\n  font-size: 15px;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-intro__compare-list li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 10px;\n  width: 4px;\n  height: 4px;\n  background: var(--fg-text-basic);\n  border-radius: 9999px;\n}\n\n.prompt-intro__compare-tag {\n  align-self: flex-start;\n  padding: 4px 6px;\n  background: var(--fg-bg-content);\n  border-radius: 4px;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n}\n\n/* Tip 카드 */\n.prompt-intro__tip {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 20px 20px 24px;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.prompt-intro__tip-number {\n  display: inline-grid;\n  place-items: center;\n  width: 46px;\n  height: 46px;\n  background: var(--fg-numbering-bg);\n  border-radius: 23px;\n  color: #fff;\n  font-size: 20px;\n  font-weight: 900;\n  line-height: 26px;\n}\n\n.prompt-intro__tip-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-intro__tip-desc {\n  margin: 0;\n  font-size: 15px;\n  line-height: 24px;\n  color: var(--fg-text-gray);\n}\n\n/* ───────── 반응형 ───────── */\n@media (max-width: 1280px) {\n  .prompt-intro__grid--5 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .prompt-intro__grid--4 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n\n/* ========================================================================\n   PromptGenerator — AI 프롬프트/Few-shot 생성 (Figma 71:2414, 71:2767)\n   ======================================================================== */\n\n.prompt-gen__section {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* 탭 */\n.prompt-gen__tabs {\n  display: flex;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.prompt-gen__tab {\n  flex: 1;\n  padding: 10px;\n  background: transparent;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n  margin-bottom: -1px;\n}\n\n.prompt-gen__tab:hover {\n  color: var(--fg-side-hover);\n}\n\n.prompt-gen__tab--active {\n  border-bottom-color: var(--fg-text-basic);\n  font-weight: 600;\n}\n\n/* 입력 폼 */\n.prompt-gen__form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.prompt-gen__label {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-gen__textarea {\n  width: 100%;\n  min-height: 162px;\n  padding: 20px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  resize: vertical;\n  outline: none;\n  transition: var(--transition-fast);\n}\n\n.prompt-gen__textarea:focus {\n  border-color: var(--fg-button);\n}\n\n.prompt-gen__textarea::placeholder {\n  color: var(--fg-text-gray);\n}\n\n.prompt-gen__form-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.prompt-gen__count {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-gen__count-select {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.prompt-gen__count-select select {\n  appearance: none;\n  -webkit-appearance: none;\n  padding: 6px 28px 6px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.prompt-gen__count-select>svg {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: var(--fg-text-gray);\n}\n\n.prompt-gen__btn-primary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 48px;\n  padding: 10px 12px;\n  background: var(--fg-button);\n  border: 0;\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  height: 42px;\n  padding: 6px 12px;\n}\n\n.prompt-gen__btn-primary:hover {\n  background: var(--fg-button-hover);\n}\n\n.prompt-gen__btn-primary--ghost {\n  background: var(--fg-bg-litepp);\n  color: var(--fg-button-hover);\n}\n\n.prompt-gen__btn-primary--ghost:hover {\n  background: #d8dbed;\n}\n\n.prompt-gen__btn-primary:disabled,\n.prompt-gen__btn-primary--ghost:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* 추천 카드 */\n.prompt-gen__suggestions {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.prompt-gen__suggestion {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 12px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  text-align: left;\n  font-family: inherit;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.prompt-gen__suggestion:hover {\n  border-color: var(--fg-button);\n}\n\n.prompt-gen__suggestion-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.prompt-gen__suggestion-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n}\n\n.prompt-gen__suggestion-summary {\n  margin: 0;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n  line-height: 1.4;\n}\n\n.prompt-gen__suggestion-tag {\n  flex-shrink: 0;\n  padding: 4px;\n  background: var(--fg-bg-warning);\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--fg-anti-red);\n}\n\n/* 결과 박스 */\n.prompt-gen__result {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n  background: #f8f8f8;\n  border-radius: 12px;\n}\n\n.prompt-gen__result-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.prompt-gen__result-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-gen__result-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.prompt-gen__btn-toolbar {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 32px;\n  padding: 5px 7px 7px;\n  border: 0;\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.prompt-gen__btn-toolbar--ghost {\n  background: var(--fg-bg-litepp);\n  color: var(--fg-button-hover);\n}\n\n.prompt-gen__btn-toolbar--ghost:hover {\n  background: #d8dbed;\n}\n\n.prompt-gen__btn-toolbar--primary {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.prompt-gen__btn-toolbar--primary:hover {\n  background: var(--fg-button-hover);\n}\n\n.prompt-gen__refresh-icon {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.prompt-gen__result-textarea {\n  width: 100%;\n  min-height: 162px;\n  padding: 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  resize: vertical;\n  outline: none;\n}\n\n.prompt-gen__result-textarea:focus {\n  border-color: var(--fg-button);\n}\n\n/* Few-shot 결과 항목 */\n.prompt-gen__fewshot-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.prompt-gen__fewshot-item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.prompt-gen__fewshot-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.prompt-gen__fewshot-row p {\n  margin: 0;\n  flex: 1;\n  font-size: 15px;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n  white-space: pre-wrap;\n}\n\n.prompt-gen__fewshot-label {\n  flex-shrink: 0;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.prompt-gen__fewshot-label--user {\n  background: var(--fg-bg-mychat);\n  color: var(--fg-button-hover);\n}\n\n.prompt-gen__fewshot-label--assistant {\n  background: var(--fg-bg-tag-lime);\n  color: var(--fg-class-green);\n}\n\n.prompt-gen__fewshot-remove {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n}\n\n.prompt-gen__fewshot-remove:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-anti-red);\n}\n\n@media (max-width: 1280px) {\n  .prompt-gen__suggestions {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n\n/* ========================================================================\n   PromptList — 프롬프트 목록 (Figma 71:3011)\n   ======================================================================== */\n\n/* 카운터 행 */\n.prompt-list__stats-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.prompt-list__stats {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.prompt-list__stat {\n  display: inline-flex;\n  align-items: end;\n  gap: 4px;\n  font-size: 15px;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n}\n\n.prompt-list__stat b {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.prompt-list__stat-divider {\n  width: 1px;\n  height: 22px;\n  background: var(--fg-line);\n}\n\n/* 필터 행 */\n.prompt-list__filter-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.prompt-list__filter-left,\n.prompt-list__filter-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.prompt-list__bulk-toggle {\n  width: 16px;\n  height: 16px;\n  display: grid;\n  place-items: center;\n  background: #c2c2c2;\n  border: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 0;\n  transition: var(--transition-fast);\n}\n\n.prompt-list__bulk-toggle--active,\n.prompt-list__bulk-toggle--partial {\n  background: var(--fg-side-hover);\n}\n\n.prompt-list__bulk-toggle:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.prompt-list__select-action-wrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.prompt-list__select-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 8px 8px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.prompt-list__select-action:hover {\n  border-color: var(--fg-button);\n}\n\n.prompt-list__select-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  z-index: 30;\n  min-width: 180px;\n  padding: 6px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  animation: prompt-list-menu-fade 120ms ease-out;\n}\n\n@keyframes prompt-list-menu-fade {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.prompt-list__select-menu-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22px;\n  color: var(--fg-text-basic);\n  text-align: left;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.prompt-list__select-menu-item>svg {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n}\n\n.prompt-list__select-menu-item:hover:not(:disabled) {\n  background: var(--fg-bg-content);\n}\n\n.prompt-list__select-menu-item:disabled {\n  color: var(--fg-text-gray);\n  cursor: not-allowed;\n}\n\n.prompt-list__select-menu-item--danger {\n  color: var(--fg-anti-red);\n}\n\n.prompt-list__select-menu-item--danger:hover:not(:disabled) {\n  background: rgba(239, 68, 68, 0.08);\n}\n\n.prompt-list__select-count {\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n/* 검색 */\n.prompt-list__search {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px 7px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 30px;\n  width: 240px;\n  height: 42px;\n}\n\n.prompt-list__search-input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: none;\n  font-family: inherit;\n  font-size: 16px;\n  background: transparent;\n  color: var(--fg-text-basic);\n}\n\n.prompt-list__search-input::placeholder {\n  color: var(--fg-text-gray);\n}\n\n.prompt-list__search>svg {\n  flex-shrink: 0;\n  color: var(--fg-text-gray);\n}\n\n/* 정렬 */\n.prompt-list__sort-wrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.prompt-list__sort {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 8px 8px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.prompt-list__sort:hover {\n  border-color: var(--fg-button);\n}\n\n.prompt-list__sort-menu {\n  right: 0;\n  left: auto;\n  min-width: 160px;\n}\n\n.prompt-list__select-menu-item--active {\n  background: var(--fg-bg-content);\n  color: var(--fg-text-purple);\n}\n\n/* 뷰 토글 */\n.prompt-list__view-toggle {\n  display: inline-flex;\n}\n\n.prompt-list__view-btn {\n  width: 42px;\n  height: 42px;\n  display: grid;\n  place-items: center;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.prompt-list__view-btn:first-child {\n  border-radius: 8px 0 0 8px;\n  border-right: 0;\n}\n\n.prompt-list__view-btn:last-child {\n  border-radius: 0 8px 8px 0;\n}\n\n.prompt-list__view-btn--active {\n  background: #dfdced;\n  color: var(--fg-button-hover);\n}\n\n/* 카드 그리드 */\n.prompt-list__cards {\n  display: grid;\n  gap: 20px;\n}\n\n.prompt-list__cards--grid {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.prompt-list__cards--list {\n  grid-template-columns: 1fr;\n}\n\n@media (max-width: 1440px) {\n  .prompt-list__cards--grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.prompt-list__empty {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--fg-text-gray);\n}\n\n/* 카드 */\n.prompt-list__card {\n  display: flex;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  transition: var(--transition-fast);\n}\n\n.prompt-list__card:hover {\n  border-color: var(--fg-button);\n}\n\n.prompt-list__card--selected {\n  border-color: var(--fg-side-hover);\n  box-shadow: 0 0 0 1px var(--fg-side-hover);\n}\n\n.prompt-list__card-check {\n  flex-shrink: 0;\n  padding-top: 6px;\n}\n\n.prompt-list__checkbox {\n  width: 16px;\n  height: 16px;\n  display: grid;\n  place-items: center;\n  background: #c2c2c2;\n  border: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 0;\n  transition: var(--transition-fast);\n}\n\n.prompt-list__checkbox--checked {\n  background: var(--fg-side-hover);\n}\n\n.prompt-list__card-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.prompt-list__card-head {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.prompt-list__card-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-list__card-date {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.prompt-list__card-summary {\n  margin: 0;\n  font-size: 15px;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n}\n\n.prompt-list__card-quote {\n  padding: 8px;\n  height: 68px;\n  background: #f8f8f8;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.prompt-list__card-quote p {\n  margin: 0;\n  font-size: 15px;\n  line-height: 24px;\n  color: var(--fg-text-gray);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.prompt-list__card-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.prompt-list__icon-btn {\n  position: relative;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.prompt-list__icon-btn:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.prompt-list__icon-btn--danger {\n  color: var(--fg-anti-red);\n}\n\n.prompt-list__icon-btn--active {\n  color: var(--fg-button);\n}\n\n.prompt-list__icon-btn-badge {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  display: grid;\n  place-items: center;\n  background: var(--fg-button);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  border-radius: 999px;\n  border: 2px solid #fff;\n  line-height: 1;\n}\n\n.prompt-list__icon-dot {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  width: 5px;\n  height: 5px;\n  background: var(--fg-anti-red);\n  border-radius: 9999px;\n}\n\n/* Few-shot 카드 (입력/출력 블록) */\n.prompt-list__card-block {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.prompt-list__card-block-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n}\n\n/* 리스트 뷰: 가로형 카드 */\n.prompt-list__cards--list .prompt-list__card-body {\n  flex-direction: row;\n  gap: 24px;\n  align-items: flex-start;\n}\n\n.prompt-list__cards--list .prompt-list__card-head {\n  flex: 0 0 200px;\n}\n\n.prompt-list__cards--list .prompt-list__card-summary {\n  flex: 0 0 240px;\n}\n\n.prompt-list__cards--list .prompt-list__card-quote {\n  flex: 1;\n  min-width: 0;\n  height: auto;\n  max-height: 68px;\n}\n\n.prompt-list__cards--list .prompt-list__card-actions {\n  flex-shrink: 0;\n}\n\n/* 모바일 전용 가로 서브내비 — 기본(데스크톱)은 숨김, ≤720px 에서만 노출 */\n.prompt__subnav-mobile {\n  display: none;\n}\n\n/* ========================================================================\n   모바일 (≤720px) — 프롬프트 화면 (Intro / Generator / List / Edit).\n   공유 셸(.prompt__*, .prompt-list__*)을 agent/mcp/edu/project 등과 함께 쓰므로\n   .prompt-page 마커로 스코프해 다른 기능 화면 영향 차단.\n   그리드는 minmax(0,1fr) 필수 — 1fr=minmax(auto,1fr) 이라 긴 콘텐츠가 트랙을\n   밀어 오버플로/잘림이 생긴다(지식베이스 파일명 잘림과 동일 원인).\n   ======================================================================== */\n@media (max-width: 720px) {\n  /* 레이아웃 — 섹션 내비는 글로벌 햄버거 드로어로 이동, 본문만 풀폭 */\n  .prompt-page .prompt__layout {\n    margin: 0 8px;\n    flex-direction: column;\n  }\n  /* 데스크톱 세로 사이드바 + 모바일 상단 탭 스트립 모두 숨김\n     (프롬프트 섹션 내비는 글로벌 드로어의 '프롬프트' 펼침 항목에서 처리) */\n  .prompt-page .prompt__sidebar { display: none; }\n  .prompt-page .prompt__subnav-mobile { display: none; }\n\n  .prompt-page .prompt__content {\n    padding: 20px 16px;\n    gap: 28px;\n  }\n\n  .prompt-page .prompt-intro__h1 {\n    font-size: 22px;\n    line-height: 32px;\n  }\n\n  /* PromptIntro — 카드 그리드 1열 */\n  .prompt-page .prompt-intro__grid--2,\n  .prompt-page .prompt-intro__grid--4,\n  .prompt-page .prompt-intro__grid--5 {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n\n  /* PromptGenerator — 추천 카드 1열, 액션 행 줄바꿈 */\n  .prompt-page .prompt-gen__suggestions {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n\n  .prompt-page .prompt-gen__form-actions,\n  .prompt-page .prompt-gen__result-actions {\n    flex-wrap: wrap;\n  }\n\n  /* PromptList — 카드 1열(그리드/리스트 공통) + 툴바 정리 */\n  .prompt-page .prompt-list__cards--grid,\n  .prompt-page .prompt-list__cards--list {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n\n  .prompt-page .prompt-list__stats-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .prompt-page .prompt-list__stats {\n    flex-wrap: wrap;\n    gap: 6px 8px;\n  }\n\n  .prompt-page .prompt-list__filter-right {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .prompt-page .prompt-list__search {\n    flex: 1;\n    width: auto;\n    min-width: 0;\n  }\n\n  /* 그리드/리스트 토글은 모바일에서 1열 고정이라 무의미 → 숨김 */\n  .prompt-page .prompt-list__view-toggle {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
